export default "__VITE_ASSET__ddcjughN__"